export function getStripeKey() {
  return 'pk_live_51OtlO6EgebfRXHhASAAchDK3RrFy8D5frTHvjhqBJYf8sobjTyQzglqfHowR33RevnSGek8UbQgOhyP94PODS12T00Jf7U0zd7';
}

export function getBackendUrl(){
  return 'https://api.meet.confhub.live/flags/';
}